export const RESET = "bookingInsurance/RESET"
export const SELECT = "bookingInsurance/SELECT"
export const DESELECT = "bookingInsurance/DESELECT"
export const SUBMIT = "bookingInsurance/SUBMIT"
export const TAB_CHANGE = "bookingInsurance/TAB_CHANGE"
export const SUBMIT_REQUEST = "bookingInsurance/SUBMIT_REQUEST"
export const SUBMIT_SUCCESS = "bookingInsurance/SUBMIT_SUCCESS"
export const SUBMIT_FAILURE = "bookingInsurance/SUBMIT_FAILURE"

export const US_INSURANCE_REFUND = "ancillaries/US_INSURANCE_REFUND"
export const US_INSURANCE_REFUND_REQUEST = "ancillaries/US_INSURANCE_REFUND_REQUEST"
export const US_INSURANCE_REFUND_SUCCESS = "ancillaries/US_INSURANCE_REFUND_SUCCESS"
export const US_INSURANCE_REFUND_FAILURE = "ancillaries/US_INSURANCE_REFUND_FAILURE"

export const NON_US_AXA_INSURANCE_REFUND = "ancillaries/NON_US_AXA_INSURANCE_REFUND"
export const NON_US_AXA_INSURANCE_REFUND_REQUEST = "ancillaries/NON_US_AXA_INSURANCE_REFUND_REQUEST"
export const NON_US_AXA_INSURANCE_REFUND_SUCCESS = "ancillaries/NON_US_AXA_INSURANCE_REFUND_SUCCESS"
export const NON_US_AXA_INSURANCE_REFUND_FAILURE = "ancillaries/NON_US_AXA_INSURANCE_REFUND_FAILURE"
